// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"1e5dab74","147":"48198676","295":"669f8f92","362":"ff952992","574":"6c85020d","818":"2e22fc48","899":"700d8341","900":"815301c4","996":"09fe7dea"}[chunkId] + ".chunk.js";
};